<template>
  <div class="sv sv011">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-green" src="sv012/main.jpg">
        <p class="heading1">いまさら聞けない！ローンの基礎知識</p>
        <h1 class="heading2">
          お金を借りたいけど、<br />周りの人に知られない？
        </h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-green _pt-sm-50"
        icon-left="sv012/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv012/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同僚の2人"
      >
        お給料日前、Bさんのお財布は大ピンチ！お金を借りることを検討しているけど、<br />
        借りたことが恋人にばれないか心配な様子。悩むBさんに同僚のAさんがアドバイスをします。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >家族・恋人・友人などに知られずにお金を借りたい！</HeadingTwo
      >

      <TalkGroup>
        <TalkBox src="sv012/avatar-b.gif"
          >今月は予定外の出費が重なってピンチ！キャッシングやローンに頼りたいけど、彼女や家族に知られないかな…</TalkBox
        >
        <TalkBox src="sv012/avatar-a.gif"
          >そんな心配しなくても大丈夫。今は、パソコンやスマートフォンで申し込みが完結するから、窓口とかに行く必要もないんだよ</TalkBox
        >
        <TalkBox src="sv012/avatar-b.gif"
          >それなら、誰かに見られる心配をしなくて済むね。でも、電話がかかってきたり、郵便物が届いたり（※１）、家族にバレるってこともありそう…</TalkBox
        >
        <TalkBox src="sv012/avatar-a.gif"
          >そんな心配も不要よ。確認のために連絡がくることはあるけど、お金を借りてることがわからないように配慮してくれるから大丈夫。それに、利用状況の確認もWEBサイトでできるし、利用するたびに郵便物が届くことはないの</TalkBox
        >
      </TalkGroup>

      <small class="-db _my-10"
        >※お申し込み内容や在職確認等のため、お電話させていただく場合がございます。また、お申し込みの際にご本人さま確認書類をアップロードを選択されたお客さまには、ご契約に必要な「確認コード」が記載されたハガキをお送りいたします。<br />
        <BtnText router-name="sv045" class="-next"
          >お申し込み手続きについて詳しくはこちら</BtnText
        ></small
      >

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >返済のときも周りに知られることはない？</HeadingTwo
      >

      <TalkGroup src="sv012/img01.jpg" class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv012/avatar-b.gif"
          >確かにそれなら、誰にも知られずに借りられるね。でも、返済のときはどうなんだろう。家や職場まで返済の集金に来たりするのかな…</TalkBox
        >
        <TalkBox src="sv012/avatar-a.gif"
          >返済は、金融機関口座引落しや口座への振込み、コンビニATMを利用することが多いよ。それに、不適切な取り立て行為は法律で厳しく禁止されているのよ。</TalkBox
        >
      </TalkGroup>

      <div class="contents-box01">
        <ContentsCard class="-green _mb-sm-30 _ml-md-20">
          <div class="card-header">
            <IconBox src="light-green" class="-md _mb-sm-10"></IconBox>
            <h3 class="heading -green">こんな行為は法律で禁止されている！</h3>
          </div>
          <div class="card-body _pt-md-25 _pb-md-10">
            <div class="card-groups">
              <div class="card-box">
                <ListGroup class="-normal">
                  <ListItem class="-normal"
                    >利用者の承諾がないのに勤務先など自宅以外の場所に訪問したり、電話やFAX送信したりすること</ListItem
                  >
                  <ListItem class="-normal"
                    >利用者の承諾がないのに早朝や夜中（午後9時から午前8時）に訪問したり、電話やFAX送信したりすること</ListItem
                  >
                  <ListItem class="-normal"
                    >しつこく何度も訪問したり、「帰ってほしい」と言われたのに帰らないこと</ListItem
                  >
                  <ListItem class="-normal"
                    >玄関先に張り紙などをして、お金を借りたことをまわりに知らせること</ListItem
                  >
                  <ListItem class="-normal"
                    >大声をあげたり乱暴な言葉を使うこと</ListItem
                  >
                </ListGroup>
              </div>
            </div>
          </div>
        </ContentsCard>
      </div>

      <TalkGroup>
        <TalkBox src="sv012/avatar-b.gif"
          >これなら申し込みや返済の時も周りの人に知られることもなさそう！</TalkBox
        >
        <TalkBox src="sv012/avatar-a.gif"
          >そうなの。お金を借りる利用者にしっかり配慮されているから安心してね</TalkBox
        >
        <TalkBox src="sv012/avatar-b.gif"
          >よーし、さっそく申し込んでみよう！</TalkBox
        >
      </TalkGroup>

      <small
        >※au PAY
        スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</small
      >

      <div class="container">
        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-normal -lg" router-name="sv002"
            >au PAY スマートローンの特徴について</BtnMain
          >
        </BtngroupSingle>
      </div>
      <CvBox class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv009" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv009/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </CardHeader>
          <CardBody
            >「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</CardBody
          >
        </CardBox>
        <CardBox router-name="sv010" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv010/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンの返済方法やルールとは？</h3>
          </CardHeader>
          <CardBody
            >「お金を借りたらどうやって返すの…？」au PAY
            スマートローンの返済方法についてはこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv011" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv011/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンって借りすぎないかな？</h3>
          </CardHeader>
          <CardBody
            >借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」なんて方はこちら。</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
import BtnText from "@/components/button/BtnText";

export default {
  name: "Sv012",
  components: {
    BreadcrumbGroup,
    BtnText,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "お金を借りたいけど、周りの人に知られない？｜いまさら聞けない！ローンの基礎知識",
      description:
        "意外と知らないローンの基礎知識！ローンの申し込みは家族に知られずできる？本人確認方法や申込方法について初心者でも分かりやすく解説します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,リスク",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "いまさら聞けない！ローンの基礎知識",
          routerName: "sv043",
        },
        {
          text: "お金を借りたいけど、周りの人に知られない？",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body {
    padding-left: 20px;
    padding-right: 20px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 0px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        > .card-image {
        }
      }
    }
  }
}

.list-group01 {
  > .list-item {
    padding-left: 27px;
    text-indent: -27px;
    @include mq-up(md) {
      padding-left: 30px;
      text-indent: -30px;
    }
  }
}
</style>
